import { render, staticRenderFns } from "./AddZonesModal.vue?vue&type=template&id=3fea9ddc&"
import script from "./AddZonesModal.vue?vue&type=script&lang=js&"
export * from "./AddZonesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports